import { render, staticRenderFns } from "./ConfigInfo.vue?vue&type=template&id=7cf4a0a5&scoped=true"
import script from "./ConfigInfo.vue?vue&type=script&lang=js"
export * from "./ConfigInfo.vue?vue&type=script&lang=js"
import style0 from "./ConfigInfo.vue?vue&type=style&index=0&id=7cf4a0a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf4a0a5",
  null
  
)

export default component.exports